import { twMerge } from 'tailwind-merge';
import { typeStyling } from './styles';
import { TypologyValue } from '@/shared';
import { t } from 'i18next';

interface TypologyProps {
  type: TypologyValue;
  counter?: number | null;
  isDisabled?: boolean;
  onClick?: () => void;
}

export const Typology = ({
  type,
  counter = null,
  isDisabled,
  onClick,
}: TypologyProps) => {
  return (
    <div
      className={twMerge(
        'flex h-min w-min rounded-3xl px-2.5 py-[5px] text-sm font-bold capitalize',
        typeStyling(type),
        isDisabled && 'bg-gray-100 text-gray-200',
        counter != null && 'cursor-pointer px-5 py-2.5',
      )}
      onClick={onClick}
    >
      <span className="flex items-center gap-2.5">
        {t(`chart_${TypologyValue[type]}_type`)}
        {counter != null && <span>{counter}</span>}
      </span>
    </div>
  );
};
